import { __rest } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["src"];
import { computed } from "vue";
import Viewport from "@/store/modules/Viewport";
export default /*#__PURE__*/ _defineComponent(Object.assign({ inheritAttrs: false }, { __name: 'UIImage', props: {
        src: {},
        alt: { default: "" },
        width: {},
        height: {},
        loading: { default: "lazy" },
        decoding: { default: "async" }
    }, setup(__props) {
        const { src } = __props, props = __rest(__props, ["src"]);
        const sources = computed(() => {
            const srcs = Array.isArray(src) ? src : [src];
            const sources = [];
            srcs.forEach((srcset) => {
                const ext = srcset.split(".").pop().toLowerCase();
                let type = "";
                switch (ext) {
                    case "jpeg":
                    case "jpg":
                        type = "image/jpeg";
                        break;
                    case "png":
                        type = "image/png";
                        break;
                    case "webp":
                        type = "image/webp";
                        // do not include webp on Safari if AVIF is present
                        if (Viewport.isSafari && sources.some((source) => source.type === "image/avif")) {
                            return;
                        }
                        break;
                    case "avif":
                        type = "image/avif";
                        if (!Viewport.isAvifSupported)
                            return;
                        break;
                }
                sources.push({ srcset, type });
            });
            return sources;
        });
        return (_ctx, _cache) => {
            return (sources.value.length > 0)
                ? (_openBlock(), _createElementBlock("picture", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sources.value, (source) => {
                        return (_openBlock(), _createElementBlock("source", _mergeProps({
                            key: source.type
                        }, source), null, 16));
                    }), 128)),
                    _createElementVNode("img", _mergeProps({
                        class: "size-full max-w-none object-cover",
                        src: sources.value[sources.value.length - 1].srcset
                    }, Object.assign(Object.assign({}, props), _ctx.$attrs)), null, 16, _hoisted_2)
                ]))
                : _createCommentVNode("", true);
        };
    } }));
